(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbw-project-inquiry"] && !Shopify.designMode) return;
  try {
    
function initializeBbwInquiry(scope){
 scope.querySelectorAll('[data-bbw-inquiry]').forEach(root=>{
  if(root.dataset.inquiryInitialized)return;
  root.dataset.inquiryInitialized='true';
  const feedback=root.querySelector('[data-bbw-inquiry-feedback]');
  const path=root.querySelector('[data-bbw-inquiry-path]');
  if(path&&!path.value&&!feedback){
   const choices={onboarding:'Onboarding and readiness',manager:'Manager development',operations:'Operational learning',practice:'Interactive learning and practice'};
   const key=new URLSearchParams(window.location.search).get('need');
   if(Object.prototype.hasOwnProperty.call(choices,key))path.value=choices[key];
  }
  if(feedback)feedback.focus();
 });
}
initializeBbwInquiry(document);
document.addEventListener('shopify:section:load',event=>initializeBbwInquiry(event.target.parentNode||document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
